import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'How We Work', href: '/how-we-work' },
    { label: 'Services', href: '/services' },
    { label: 'Results', href: '/results' },
    { label: 'About', href: '/about' },
    { label: 'Insights', href: '/insights' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <header className="fixed w-full top-0 z-50 bg-white border-b border-gray-100" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex-shrink-0" data-testid="header-logo">
            <img src="/assets/kalobrate-wordmark-carbon.png" alt="Kalobrate" className="h-7 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.href ? 'text-golden' : 'text-carbon hover:text-golden'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="ml-2 bg-golden text-carbon px-5 py-2 text-sm font-semibold hover:bg-golden/90 transition-colors"
              data-testid="talk-to-ollie-btn"
            >
              Talk to Ollie
            </Link>
          </nav>

          <button
            className="lg:hidden p-2 text-carbon"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg" data-testid="mobile-nav">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="py-2.5 px-3 text-sm font-medium text-carbon hover:bg-gray-50 transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-2 bg-golden text-carbon px-5 py-2.5 text-sm font-semibold text-center hover:bg-golden/90 transition-colors"
              onClick={() => setMobileOpen(false)}
              data-testid="mobile-talk-to-ollie-btn"
            >
              Talk to Ollie
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
